import { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Area, AreaChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { getWorkOrderOverview } from '../../store/Slices/WorkOrderSlice';
import { createIssueIcon, openIssueIcon, pendingSvgIcon, resolvedIssueIcon, visualizeChartBlackIcon, visualizeChartWhiteIcon } from '../../utils/svgs';

const WorkOrdersChart = () => {
    const dispatch = useDispatch();
    const [showChart, setShowChart] = useState(false);

    const { workOrderOverviewData } = useSelector((state) => state.workOrder)


    useEffect(() => {
        dispatch(getWorkOrderOverview());
    }, [])

    // Prepare chart data
    const createdData = workOrderOverviewData?.created?.createdChart?.map(item => ({
        month: item.month,
        count: item.count
    })) || [];

    const openData = workOrderOverviewData?.open?.openChart?.map(item => ({
        month: item.month,
        count: item.count
    })) || [];

    const pendingData = workOrderOverviewData?.pending?.pendingChart?.map(item => ({
        month: item.month,
        count: item.count
    })) || [];

    const completedData = workOrderOverviewData?.completed?.completedChart?.map(item => ({
        month: item.month,
        count: item.count
    })) || [];

    return (
        <div className='service_box_chart_main'>
            <div className='service_box_chart'>
                {
                    !showChart ?
                        <span onClick={() => setShowChart(!showChart)}>{visualizeChartBlackIcon}</span>
                        :
                        <span onClick={() => setShowChart(!showChart)}>{visualizeChartWhiteIcon}</span>
                }
            </div>

            <div>
                <Row>
                    <Col md={3}>
                        <div className='service_box_chart_item'>
                            <div className='item_details'>
                                <div>
                                    <h6>Created</h6>
                                    <div>{workOrderOverviewData?.created?.total || 0}</div>
                                    <p>
                                        <b>
                                            {workOrderOverviewData && workOrderOverviewData?.created?.percentageChangeFromLastMonth || 0}%
                                        </b> {workOrderOverviewData?.created?.direction} from Last Month
                                    </p>
                                </div>
                                <div>
                                    <span>{createIssueIcon}</span>
                                </div>
                            </div>
                            {
                                showChart &&
                                <div style={{ width: '100%', height: 180, marginTop: 15 }}>
                                    <ResponsiveContainer>
                                        <AreaChart
                                            data={createdData}
                                            margin={{ top: 10, right: 0, left: -25, bottom: 0 }}
                                        >
                                            <defs>
                                                <linearGradient id="colorCount" x1="0" y1="0" x2="0" y2="1">
                                                    <stop offset="0%" stopColor="#43b649" stopOpacity={0.8} />
                                                    <stop offset="100%" stopColor="#43b649" stopOpacity={0.2} />
                                                </linearGradient>
                                            </defs>
                                            <XAxis dataKey="month" tick={{ fontSize: 13 }} />
                                            <YAxis tick={{ fontSize: 13 }} />
                                            <CartesianGrid strokeDasharray="3 3" />
                                            <Tooltip />
                                            <Area
                                                type="monotone"
                                                dataKey="count"
                                                stroke="#43b649"
                                                fill="url(#colorCount)"
                                                strokeWidth={2}
                                            />
                                        </AreaChart>
                                    </ResponsiveContainer>
                                </div>
                            }

                        </div>
                    </Col>
                    <Col md={3}>
                        <div className='service_box_chart_item'>
                            <div className='item_details'>
                                <div>
                                    <h6>Open</h6>
                                    <div>{workOrderOverviewData?.open?.total || 0}</div>
                                    <p>
                                        <b>
                                            {workOrderOverviewData && workOrderOverviewData?.open?.percentageChangeFromLastMonth || 0}%
                                        </b> {workOrderOverviewData?.open?.direction} from Last Month
                                    </p>
                                </div>
                                <div>
                                    <span>{openIssueIcon}</span>
                                </div>
                            </div>
                            {
                                showChart &&
                                <div style={{ width: '100%', height: 180, marginTop: 15 }}>
                                    <ResponsiveContainer>
                                        <AreaChart
                                            data={openData}
                                            margin={{ top: 10, right: 0, left: -15, bottom: 0 }}
                                        >
                                            <defs>
                                                <linearGradient id="serviceCost" x1="0" y1="0" x2="0" y2="1">
                                                    <stop offset="0%" stopColor="#FF9500" stopOpacity={0.8} />
                                                    <stop offset="100%" stopColor="#FF9500" stopOpacity={0.2} />
                                                </linearGradient>
                                            </defs>
                                            <XAxis dataKey="month" tick={{ fontSize: 13 }} />
                                            <YAxis tick={{ fontSize: 13 }} />
                                            <CartesianGrid strokeDasharray="3 3" />
                                            <Tooltip />
                                            <Area
                                                type="monotone"
                                                dataKey="count"
                                                stroke="#FF9500"
                                                fill="url(#serviceCost)"
                                                strokeWidth={2}
                                            />
                                        </AreaChart>
                                    </ResponsiveContainer>
                                </div>
                            }
                        </div>
                    </Col>
                    <Col md={3}>
                        <div className='service_box_chart_item'>
                            <div className='item_details'>
                                <div>
                                    <h6>Pending</h6>
                                    <div>{workOrderOverviewData?.pending?.total || 0}</div>
                                    <p>
                                        <b>
                                            {workOrderOverviewData && workOrderOverviewData?.pending?.percentageChangeFromLastMonth || 0}%
                                        </b> {workOrderOverviewData?.pending?.direction} from Last Month
                                    </p>
                                </div>
                                <div>
                                    <span>{pendingSvgIcon}</span>
                                </div>
                            </div>
                            {
                                showChart &&
                                <div style={{ width: '100%', height: 180, marginTop: 15 }}>
                                    <ResponsiveContainer>
                                        <AreaChart
                                            data={pendingData}
                                            margin={{ top: 10, right: 0, left: -25, bottom: 0 }}
                                        >
                                            <defs>
                                                <linearGradient id="pendingMaintenance" x1="0" y1="0" x2="0" y2="1">
                                                    <stop offset="0%" stopColor="#F8E34F" stopOpacity={0.8} />
                                                    <stop offset="100%" stopColor="#F8E34F" stopOpacity={0.2} />
                                                </linearGradient>
                                            </defs>
                                            <XAxis dataKey="month" tick={{ fontSize: 13 }} />
                                            <YAxis tick={{ fontSize: 13 }} />
                                            <CartesianGrid strokeDasharray="3 3" />
                                            <Tooltip />
                                            <Area
                                                type="monotone"
                                                dataKey="count"
                                                stroke="#F8E34F"
                                                fill="url(#pendingMaintenance)"
                                                strokeWidth={2}
                                            />
                                        </AreaChart>
                                    </ResponsiveContainer>
                                </div>
                            }
                        </div>
                    </Col>
                    <Col md={3}>
                        <div className='service_box_chart_item'>
                            <div className='item_details'>
                                <div>
                                    <h6>Completed</h6>
                                    <div>{workOrderOverviewData?.completed?.total || 0}</div>
                                    <p>
                                        <b>
                                            {workOrderOverviewData && workOrderOverviewData?.completed?.percentageChangeFromLastMonth || 0}%
                                        </b> {workOrderOverviewData?.completed?.direction} from Last Month
                                    </p>
                                </div>
                                <div>
                                    <span>{resolvedIssueIcon}</span>
                                </div>
                            </div>
                            {
                                showChart &&
                                <div style={{ width: '100%', height: 180, marginTop: 15 }}>
                                    <ResponsiveContainer>
                                        <AreaChart
                                            data={completedData}
                                            margin={{ top: 10, right: 0, left: -25, bottom: 0 }}
                                        >
                                            <defs>
                                                <linearGradient id="colorUpcoming" x1="0" y1="0" x2="0" y2="1">
                                                    <stop offset="0%" stopColor="#4014B8" stopOpacity={0.5} />
                                                    <stop offset="100%" stopColor="#4014B8" stopOpacity={0.1} />
                                                </linearGradient>
                                            </defs>
                                            <XAxis dataKey="month" tick={{ fontSize: 13 }} />
                                            <YAxis tick={{ fontSize: 13 }} />
                                            <CartesianGrid strokeDasharray="3 3" />
                                            <Tooltip />
                                            <Area
                                                type="monotone"
                                                dataKey="count"
                                                stroke="#4014B8"
                                                fill="url(#colorUpcoming)"
                                                strokeWidth={2}
                                            />
                                        </AreaChart>
                                    </ResponsiveContainer>
                                </div>
                            }
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    )
}

export default WorkOrdersChart;